export default __webpack_public_path__ + "static/media/LOGO-KATOMI.edfe5929.png";